<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-area section-space--ptb_90">
            <div class="container">
                <div class="row mb-40">
                    <div class="col footer-widget">
                        <div class="footer-widget__logo mb-20">
                            <router-link to="/">
                                <img src="../assets/img/logo/RootiCare_logo.png" class="img-fluid" alt="logo">
                            </router-link>
                        </div>
                    </div>
                    <div class="col footer-widget">
                        <h6 class="footer-widget__title footer-mb">Introduction</h6>
                        <ul class="footer-widget__list">
                            <li>
                                <router-link to="/about-us" class="footer-text">About us</router-link>
                            </li>
                            <li>
                                <router-link to="/" class="footer-text">Why Us</router-link>
                            </li>
                            <li>
                                <router-link to="/how-work" class="footer-text">How it Works</router-link>
                            </li>
                            <li>
                                <router-link to="/electrocardiogram" class="footer-text">
                                    Electrocardiogram (ECG)
                                </router-link>
                            </li>
                            <li>
                                <span class="footer-text"> Our Security Policy : </span>
                                <a href="/document/Our Security Policy_www_ENG.pdf" target="_blank"
                                    class="footer-text font-bold">
                                    EN
                                </a>
                                <span class="footer-text" style="padding-left: 5px;"> / </span>
                                <a href="/document/Our Security Policy_www_TW.pdf" target="_blank"
                                    class="footer-text font-bold" style="padding-left: 5px;">
                                    中文
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col footer-widget">
                        <h6 class="footer-widget__title footer-mb">Resources</h6>
                        <ul class="footer-widget__list">
                            <li>
                                <router-link to="/rooti-care" class="footer-text">RootiCare System</router-link>
                            </li>
                            <li>
                                <router-link to="/rooti-rx" class="footer-text">Rooti Rx System</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4 footer-widget">

                    </div>
                    <div class="col footer-widget">
                        <h6 class="footer-widget__title footer-mb" style="width: 38.87%;">Contact Info</h6>
                        <ul class="footer-widget__list">
                            <li>
                                <span class="footer-text">
                                    5F.-1, No.71, Zhouzi St., Neihu Dist., Taipei City 114, Taiwan
                                </span>
                            </li>
                            <li>
                                <span class="footer-text">
                                    T: +886-2-656-0618 E: <a
                                        href="mailto: service@rootilabs.com">service@rootilabs.com</a>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footer-reserve">
                © 2016 Rooti Labs Limited. All right reserved.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["FooterStyle"]
}
</script>

<style>
.footer-reserve {
    color: #CAE1E0;
    position: relative;
    left: 320px;
    top: 40px;
}

.footer-text {
    color: white;
    font-size: 17px;
}

.footer-area-wrapper a:hover {
    color: #d0f255;
}
</style>